<script>
  import NavBarReusable from './NavbarReusable.svelte';
  import AdminActivityDashboard from './AdminActivityDashboard.svelte';
</script>

<div class="app-container activity-dashboard-page">
  <NavBarReusable label="Activity Dashboard" backLink="/admin/all" />
  <AdminActivityDashboard />
</div>

<style>
  .activity-dashboard-page {
    min-height: 100vh;
    width: 100%;
    background: #070b12;
  }
</style>
